module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/export-6fd761772e25def95fc5771cb6e2ceb3.svg";